import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { PlatformCard, Platform, PlatformType } from '../components/PlatformCard';
import { ArrowLeft } from 'lucide-react';
export function PlatformsPage() {
  const navigate = useNavigate();
  const [platforms, setPlatforms] = useState<Platform[]>([{
    id: 'instagram',
    name: 'Instagram',
    isConnected: true
  }, {
    id: 'facebook',
    name: 'Facebook',
    isConnected: false
  }, {
    id: 'youtube',
    name: 'YouTube',
    isConnected: false
  }, {
    id: 'twitter',
    name: 'X (Twitter)',
    isConnected: false
  }, {
    id: 'tiktok',
    name: 'TikTok',
    isConnected: true
  }]);
  const handleConnect = async (id: PlatformType) => {
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 2000));
    setPlatforms(prev => prev.map(p => p.id === id ? {
      ...p,
      isConnected: !p.isConnected
    } : p));
  };
  return <div className="min-h-screen bg-gray-50 pb-12" data-id="element-1227">
      <header className="bg-white border-b sticky top-0 z-10" data-id="element-1228">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-1229">
          <div className="flex items-center" data-id="element-1230">
            <Button variant="ghost" size="sm" className="mr-4" onClick={() => navigate('/manager')} data-id="element-1231">
              <ArrowLeft className="h-4 w-4 mr-2" data-id="element-1232" /> Back
            </Button>
            <h1 className="text-xl font-bold text-gray-900" data-id="element-1233">
              Connect Platforms
            </h1>
          </div>
        </div>

        {/* Tabs */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1234">
          <div className="flex space-x-8 -mb-px" data-id="element-1235">
            <button onClick={() => navigate('/manager')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-1236">
              Overview
            </button>
            <button onClick={() => navigate('/manager/brands')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-1237">
              Brands
            </button>
            <button onClick={() => navigate('/manager/projects')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-1238">
              Projects
            </button>
            <button className="pb-4 text-sm font-medium text-blue-600 border-b-2 border-blue-600" data-id="element-1239">
              Platforms
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1240">
        <div className="mb-8" data-id="element-1241">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-1242">
            Manage Integrations
          </h2>
          <p className="text-muted-foreground" data-id="element-1243">
            Connect your social media accounts to track performance across all
            channels.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1244">
          {platforms.map(platform => <PlatformCard key={platform.id} platform={platform} onConnect={handleConnect} data-id="element-1245" />)}
        </div>
      </main>
    </div>;
}